import React, { useEffect, useState } from "react";
import "../styles/ViewOrderProd.css";
import { useStateContext } from "../contexts/ContextProvider";
import { GetPartInvById } from "../api";
import { MdOutlineCancel } from "react-icons/md";

const ViewOrderPart = () => {
  const {
    activeProdMenu,
    setActiveProdMenu,
    activeProdMenuId,
    setActiveProdMenuId,
  } = useStateContext();
  const [Part, setPart] = useState("");

  useEffect(() => {
    async function fetchData() {
      if (activeProdMenuId.part_id && activeProdMenuId.store_id) {
        const { part_id, store_id } = activeProdMenuId;
        await GetPartInvById(part_id, store_id)
          .then((resp) => {
            setPart(resp.data);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [activeProdMenu, activeProdMenuId]);

  return (
    <div className=" h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-3 pt-3">
      {activeProdMenu && (
        <aside>
          <button
            onClick={() => {
              setActiveProdMenu(false);
              setActiveProdMenuId({ part_id: null, store_id: null });
            }}
            className="text-xl rounded-full p-3 hover:bg-light-gray block"
          >
            <MdOutlineCancel />
          </button>
          <div>
            <label className="text-2xl w-100 font-bold text-center">
              More about Part
            </label>
            <hr className="line" />
            {/* {defaultImageMode && (
              <>
                {Part.image_url && (
                  <div
                    className="rounded"
                    style={{
                      width: "92%",
                      height: "256px",
                      textAlign: "center",
                      backgroundColor: "lightgray",
                      margin: "4%",
                    }}
                  >
                    <img
                      src={`${Part.image_url}`}
                      alt={`Part ${Part.part_id}`}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                        textAlign: "center",
                      }}
                    />
                  </div>
                )}
                <hr className="line" style={{ paddingBottom: "4px" }} />
              </>
            )} */}
            <div className="pl-6 pr-6">
              <label className="w-100 text-xl text-center font-bold">{`${Part.part_no}`}</label>
              <label className="w-100 text-sm text-center pb-4">{`${Part.description}`}</label>
              <label>
                <span className="text-md">{`Category: `}</span>
                <span className="text-lg font-light">{`${Part.category}`}</span>
              </label>
              <label>
                <span className="text-md">{`Company: `}</span>
                <span className="text-lg font-light">{`${Part.company}`}</span>
              </label>
              <label>
                <span className="text-md">{`Inventory InStock: `}</span>
                <span className="text-lg font-light">{`${Part.unit_instock} ${Part.unit}`}</span>
              </label>
            </div>
            <hr className="line" />
          </div>
        </aside>
      )}
    </div>
  );
};

export default ViewOrderPart;
